import { EfectivizarTransferenciaExternaMS } from './../../../open-api/model/efectivizarTransferenciaExternaMS';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-transferext-invoice',
  templateUrl: './transferext-invoice.component.html',
  styleUrls: ['./transferext-invoice.component.scss']
})
export class TransferextInvoiceComponent implements OnInit {

  @Input() comprobante?: EfectivizarTransferenciaExternaMS;
  fecha = new Date().toLocaleDateString();
  constructor() { }

  ngOnInit(): void {
  }

}
